// The server represents a supervising provider with several states as one {id, name, state}
// entry per state (state may be null); the UI works with one {id, name, states} entry per provider.

export const groupSupervisingProviders = (entries) => {
  const byId = new Map();
  (entries || []).forEach((entry) => {
    if (!byId.has(entry.id)) {
      byId.set(entry.id, { id: entry.id, name: entry.name, states: [] });
    }
    if (entry.state && !byId.get(entry.id).states.includes(entry.state)) {
      byId.get(entry.id).states.push(entry.state);
    }
  });
  byId.forEach((provider) => provider.states.sort());
  return [...byId.values()];
};

export const flattenSupervisingProviders = (providers) =>
  (providers || []).flatMap((provider) =>
    provider.states && provider.states.length > 0
      ? provider.states.map((state) => ({ id: provider.id, state }))
      : [{ id: provider.id, state: null }]);

// Applies the grouping to a provider response's supervising and supervised lists
export const withGroupedSupervisors = (result) => {
  if (!result) {
    return result;
  }
  const grouped = { ...result };
  ["supervisingProviders", "supervisedProviders"].forEach((key) => {
    if (result[key]) {
      grouped[key] = groupSupervisingProviders(result[key]);
    }
  });
  return grouped;
};
